import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Chip, Typography } from '@mui/material'

export const AccessStatus: FC<{ granted: boolean }> = ({ granted }) => {
  const { t } = useTranslation()
  return granted ? (
    <Chip size="small" color="success" variant="outlined" label={t('internal-csm:organization_access_has_access')} />
  ) : (
    <Typography variant="body2" color="text.secondary">
      ---
    </Typography>
  )
}
